module.exports = __webpack_public_path__ + "img/tv_dark.7c7ad380.svg";